export default __webpack_public_path__ + "static/media/guest_11_01_yasmin_vitoria.4cb39140.png";